import React from 'react';
import styled from 'styled-components';

const LogoStyle = styled.img`
  position: absolute;
  z-index: -1;
  top: 10%;
  bottom: 0;
  left: 35%;
  right: 0;
  opacity: 0.2;
  height: 80vh;
`;

export default function LogoBackground() {
  return <LogoStyle id="imageBackground" src="/images/logos/SPA_Vetor.png" alt="Logo Spa" />;
}
